export default __webpack_public_path__ + "static/media/pro-elevate-bpn-1.050734b9.png";